import api from './api';

export interface Notification {
    id: number;
    title: string;
    content: string;
    date: string;
    time: string;
    repeat: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}

interface NotificationResponse {
    data: Notification[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export const fetchNotifications = async (page: number = 1, limit: number = 10): Promise<NotificationResponse> => {
    try {
        const response = await api.get<NotificationResponse>('/push-notifications', {
            params: { page, limit }
        });
        console.log('Notifications', response.data);

        return response.data;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};

export const createNotification = async (data: Partial<Notification>): Promise<Notification> => {
    try {
        const response = await api.post<Notification>('/push-notifications', data);
        console.log('Notification', response.data);

        return response.data;
    } catch (error) {
        console.error('Error creating notification:', error);
        throw error;
    }
};

export const updateNotification = async (id: number, data: Partial<Notification>): Promise<Notification> => {
    try {
        const response = await api.put<Notification>(`/push-notifications/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating notification:', error);
        throw error;
    }
};

export const deleteNotification = async (id: number): Promise<void> => {
    try {
        const response = await api.delete(`/push-notifications/${id}`);
        if (response.status !== 200) {
            throw new Error('Failed to delete notification');
        }
    } catch (error) {
        console.error('Error deleting notification:', error);
        throw error;
    }
};

